declare const swiper: any; // komt uit script.js

const API_URL = "https://wa-tnh-prd-technichallengeapi.azurewebsites.net";
const POLL_INTERVAL = 10000;      // normaal elke 10 seconden de status ophalen
const MAX_POLL_INTERVAL = 30000;  // bij storing niet vaker dan elke 30 seconden opnieuw proberen
const REQUEST_TIMEOUT = 8000;     // request afbreken als de server niet op tijd antwoordt

class Kamer {
  kamer: any;
  data: any;
  status: string = null;
  timer: any = null;
  pollId = 0;
  failures = 0;
  submitting = false;
  message: JQuery = null;

  constructor() {

    this.kamer = $(".js-room").attr('data-kamerid');
    $(".is-progressbar").hide();
    $(".swiper-container").hide();
    $(".js-start").hide();
    $(".js-startbtn").on("click", function() {
      $(".js-start").hide();
    $(".swiper-container").show();
    $(".is-progressbar").show();
    })
    // Eén keer koppelen: voorheen kwam er bij elke ronde een extra handler bij,
    // waardoor één klik op Klaar meerdere inzendingen en polling-lussen startte.
    $(".js-endbtn").on("click", () => this.endGame());
    if (this.kamer) {
      this.poll();
    } else {
      console.error("Kamer ID not found or not set.");
    }
  }

  // Er staat altijd maar één poll gepland: een nieuwe planning vervangt de vorige.
  schedule(delay: number) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.poll(), delay);
  }

  poll() {
    const id = ++this.pollId;
    $.ajax({
      url: `${API_URL}/Kamer/Status?kamerId=${this.kamer}`,
      type: 'POST',
      timeout: REQUEST_TIMEOUT,
      success: (data) => {
        if (id !== this.pollId) return; // antwoord van een inmiddels ingehaalde poll
        if (this.failures >= 2) this.hideMessage();
        this.failures = 0;
        // Eerst de volgende poll plannen, zodat een fout in applyStatus de lus niet stopt.
        this.schedule(POLL_INTERVAL);
        this.applyStatus(data);
      },
      error: (jqXHR, textStatus, errorThrown) => {
        if (id !== this.pollId) return;
        console.error('Error fetching room status:', textStatus, errorThrown);
        // Blijven proberen na een fout (voorheen stopte het pollen hier voorgoed),
        // met oplopende wachttijd zodat een gestoorde API niet extra belast wordt.
        this.failures++;
        if (this.failures >= 2) {
          this.showMessage("Geen verbinding met de server. Er wordt automatisch opnieuw geprobeerd...");
        }
        this.schedule(Math.min(POLL_INTERVAL * this.failures, MAX_POLL_INTERVAL));
      }
    });
  }

  applyStatus(data) {
    if (!data) return;
    const vorigeStatus = this.status;
    const vorigeRonde = this.data ? this.data.rondeID : null;
    this.data = data;
    this.status = data.status;

    if(data.status == "actief") {
      // Alleen bij een nieuwe of heropende ronde het scherm resetten, niet bij elke poll.
      if (vorigeStatus == "actief" && vorigeRonde == data.rondeID) return;
      swiper.slideTo(0);
      if($(".js-vraag").length) {
        $(".js-vraag[type='text']").each((index, item) => {
            $(item).val('');
        });
        $(".js-vraag[type='radio']").each((index, item) => {
            $(item).prop('checked', false);
        });
      }
      $(".js-teamsLeden").text(data.teamsLeden);
      $(".js-locked").addClass("is-hidden");
      $(".js-goedkeuring").addClass("is-hidden");
      $(".js-start").show();
      $(".js-endbtn").prop("disabled", false);
    }
    if(data.status == "goedkeuring") {
        $(".js-locked").addClass("is-hidden");
        $(".js-goedkeuring").removeClass("is-hidden")
        $(".is-progressbar").hide();
    }
    if(data.status == "vrij") {
      $(".swiper-container").hide();
      $(".is-progressbar").hide();
      $(".js-goedkeuring").addClass("is-hidden")
      $(".js-locked").removeClass("is-hidden");
    }
  }

  endGame() {
    if (this.submitting) return; // dubbelklikken levert geen dubbele inzending op
    this.submitting = true;
    $(".js-endbtn").prop("disabled", true);
    this.hideMessage();

    var antwoorden = "";
    if($(".js-vraag").length) {
      $(".js-vraag").each((index, item) => {
          if ($(item).attr('type') === 'radio' && !$(item).is(':checked')) {
               return; // Skip this iteration
           }else {
             let vraag = $(item).attr('data-vraag');
             let antwoord = $(item).val();
             let echtantwoord = $(item).attr('data-antwoord');
             antwoorden += 'Vraag: '+vraag+'<br/>Gegeven antwoord: '+antwoord+'<br/>Echte antwoord: '+echtantwoord+'<br/><br/>'
           }
        });
    }else {
      antwoorden = "Deze kamer heeft geen vragen."
    }
    // encodeURIComponent: een & of # in een antwoord brak anders de URL af
    const url = `${API_URL}/Ronde/Indienen?rondeId=${this.data.rondeID}&antwoord=${encodeURIComponent(antwoorden)}`;

    $.ajax({
      url: url,
      type: 'POST',
      timeout: REQUEST_TIMEOUT,
      success: () => {
        $(".swiper-container").hide();
        this.schedule(0); // direct de nieuwe status ophalen, binnen dezelfde lus
      },
      error: (jqXHR, textStatus, errorThrown) => {
        console.error('Error submitting answers:', textStatus, errorThrown);
        console.error('Response Text:', jqXHR.responseText);
        $(".js-endbtn").prop("disabled", false);
        this.showMessage("Inleveren is niet gelukt. Druk nogmaals op Klaar.");
      },
      complete: () => {
        this.submitting = false;
      }
    });
  }

  // Zichtbare melding onderaan het scherm, zodat het personeel ziet dat een device geen contact heeft.
  showMessage(text: string) {
    if (!this.message) {
      this.message = $('<div class="js-verbinding"></div>').css({
        position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 9999,
        padding: "16px", background: "#cf122d", color: "#fff",
        textAlign: "center", fontSize: "28px"
      }).appendTo("body");
    }
    this.message.text(text).show();
  }

  hideMessage() {
    if (this.message) this.message.hide();
  }
}

$(document).ready(() => {
  let kamer = new Kamer();
});
